import { Container } from '@material-ui/core';
import styled from 'styled-components';
import breakpoints from 'utils/breakpoints';

export const StyledContainer = styled(Container)`
  && {
    @media (max-width: ${breakpoints.xs}) {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }
`;
